import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Container, Space, Typography, getTypographyDefaultColor } from '@ag1/ui';
import { AnchorNavigation } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import styles from './AnchorNavigation.module.scss';
import { StudioBaseIconV2 } from '../StudioBaseIcon/StudioBaseIcon';
import CustomPortableText from '../PortableText/PortableText';

type Props = {
  anchors: AnchorNavigation['anchors'];
  headline: AnchorNavigation['headline'];
  bgColor: AnchorNavigation['bgColor'];
  padding: AnchorNavigation['padding'];
  theme: AnchorNavigation['theme'];
  setActiveLinkWithScroll: (link: string) => void;
};

export const CardsWithIconsNavigation = forwardRef<HTMLDivElement, Props>(
  ({ anchors, padding, theme, bgColor, headline, setActiveLinkWithScroll }, ref) => (
    <Space
      top={{ xxs: 24, s: 40, m: 60 }}
      bottom={{ xxs: 24, s: 40, m: 60 }}
      className={clsx(
        bgColor === 'stone' ? styles.stoneBg : '',
        getSectionPaddingClasses(styles, padding)
      )}>
      {headline && (
        <Container narrow>
          <Typography
            variant="subtitle"
            size="1"
            weight="700"
            noPadding
            color={getTypographyDefaultColor(theme)}
            className={styles.cardsWithIconHeadline}>
            <CustomPortableText value={headline} />
          </Typography>
        </Container>
      )}

      <nav className={styles.stone} role="navigation" data-variant="cardsWithIcons" ref={ref}>
        <Container narrow>
          <ul className={styles.list}>
            {anchors &&
              anchors.map((anchor) => (
                <li
                  key={anchor.anchorTitle}
                  className={clsx(styles.listItem, getThemeCSSClass(theme))}>
                  <button
                    type="button"
                    className={clsx(styles.buttonLink, getThemeCSSClass(theme))}
                    onClick={() => setActiveLinkWithScroll(anchor.anchorLink)}>
                    {anchor.icon && <StudioBaseIconV2 icon={anchor.icon} className={styles.icon} />}

                    <span className={clsx(styles.text, getThemeCSSClass(theme))}>
                      {anchor.anchorTitle}
                    </span>
                  </button>
                </li>
              ))}
          </ul>
        </Container>
      </nav>
    </Space>
  )
);

CardsWithIconsNavigation.displayName = 'CardsWithIconsNavigation';
